/** What the browser says of an error in another site's script, and nothing else. */
const OPAQUE = /^Script error\.?$/;

/**
 * An error event that says only "Script error.": a script from another
 * site (an ad pixel, PostHog's own, a browser extension) threw, and the
 * browser hid its message, file and stack. Nothing in it can be fixed
 * here, so analytics does not send it.
 */
export function isOpaqueScriptError(event: {
    event?: string;
    properties?: Record<string, unknown>;
}): boolean {
    if (event.event !== "$exception") return false;
    const list = event.properties?.$exception_list;
    if (!Array.isArray(list) || list.length === 0) return false;
    return list.every((exception: unknown) => {
        if (typeof exception !== "object" || exception === null) return false;
        const { value, stacktrace } = exception as { value?: unknown; stacktrace?: unknown };
        const frames = (stacktrace as { frames?: unknown } | undefined)?.frames;
        const framed = Array.isArray(frames) && frames.length > 0;
        return typeof value === "string" && OPAQUE.test(value.trim()) && !framed;
    });
}
